import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import Menu from "./components/menu";
import Nav from "./components/nav";
import Progress from "./components/progress";
import Toaster from "./components/toaster";
import ConfirmEmailPage from "./containers/login/confirmEmail.page";
import LoginPage from "./containers/login/login.page";
import ResetHaslaPage from "./containers/login/resetHasla.page";
import ResetHaslaInitPage from "./containers/login/resetHaslaInit.page";
import SingupPage from "./containers/login/signup.page";
import OrganizacjePage from "./containers/organizacje/organizacje.page";
import DaneOsobistePage from "./containers/profil/daneosobiste.page";
import ZmianaHaslaPage from "./containers/profil/zmianahasla.page";
import UzytkownicyPage from "./containers/uzytkownicy/uzytkownicy.page";
import ZaproszeniePage from "./containers/zaproszenie/zaproszenie.page";
import ZaproszenieErrorPage from "./containers/zaproszenie/zaproszenieError.page";
import useWybranaOrganizacja from "./hooks/useWybranaOrganizacja";
import { IDRaksStore } from "./store/store";
import { NOT_SELECTED_ID, OrganizacjaWidok } from "./store/types/organizacje";
import AppStyle from "./styles/AppStyle";
import createHistory from "history/createBrowserHistory";
import { authActions } from "./store/actions/auth.actions";
import { DaneOsobiste } from "./store/types/auth";
import { mixpanelService } from "./services/mixpanel.service";
import { settingsActions } from "./store/actions/settings.actions";

interface AppProps {
  isLogged: boolean;
  organizacje: OrganizacjaWidok[];
  zaproszenieError: string;
  onGetPersonalData: Function;
  email: string;
  onDajDostepneProdukty: Function;
}

function App(props: AppProps) {
  const {
    isLogged,
    organizacje,
    zaproszenieError,
    onGetPersonalData,
    email,
    onDajDostepneProdukty,
  } = props;
  const [permanent, setPermanent] = useState(true);
  const { zmienWybrana, wybierzPierwszaOrganizacje } = useWybranaOrganizacja();
  const history = createHistory();

  useEffect(() => {
    // start mixpanela
    mixpanelService.start();
    // wczytanie ustawień
    onDajDostepneProdukty();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isLogged) {
      const id = window.location.pathname.split("/")[1];
      if (id === NOT_SELECTED_ID) wybierzPierwszaOrganizacje(organizacje);
      else zmienWybrana(id);
    }
    // eslint-disable-next-line
  }, [isLogged, organizacje]);

  useEffect(() => {
    if (zaproszenieError) {
      history.push("/zaproszenieerror");
      window.location.reload();
    }
    // eslint-disable-next-line
  }, [zaproszenieError]);

  useEffect(() => {
    // identyfikacja usera w HelpScout
    var beacon = (window as any).Beacon;
    if (beacon) {
      if (isLogged) {
        onGetPersonalData().then((dto: DaneOsobiste) => {
          if (dto) {
            var nazwisko = !(dto.Imie || dto.Nazwisko)
              ? "[BRAK DANYCH]"
              : `${dto.Imie || ""} ${dto.Nazwisko || ""}`;
            beacon("identify", {
              name: nazwisko,
              email: email,
            });
          }
        });
      } else beacon("logout");
    }
    // eslint-disable-next-line
  }, [isLogged]);

  return (
    <AppStyle isLogged={isLogged} isPermanent={permanent}>
      <Toaster />
      <Progress />
      {isLogged && (
        <Menu
          permanent={permanent}
          handlePermanent={() => setPermanent(!permanent)}
          appName="raks"
        >
          <Nav />
        </Menu>
      )}
      {isLogged ? (
        <Switch>
          <Route
            path={[
              "/",
              "/login",
              "/signup",
              "/loginproxy/:product/:host/:redirect",
            ]}
            exact
            render={() => <Redirect to={`/${NOT_SELECTED_ID}/organizacje`} />}
          />
          <Route
            path="/:idorganizacji/organizacje"
            exact
            component={OrganizacjePage}
          />
          <Route
            path="/:idorganizacji/daneosobiste"
            exact
            component={DaneOsobistePage}
          />
          <Route
            path="/:idorganizacji/zmianahasla"
            exact
            component={ZmianaHaslaPage}
          />
          <Route
            path="/:idorganizacji/uzytkownicy"
            exact
            component={UzytkownicyPage}
          />
          <Route
            path="/confirmemail/:email/:token"
            exact
            component={ConfirmEmailPage}
          />
          <Route
            path={[
              "/invitation/:idorganizacji/:idzaproszenia",
              "/invitation/:idorganizacji/:idzaproszenia/:host/:redirect",
            ]}
            exact
            component={ZaproszeniePage}
          />
          <Route path="*" component={OrganizacjePage} />
        </Switch>
      ) : (
        <Switch>
          <Route
            path={[
              "/signup",
              "/signupinvite/:idorganizacji/:idzaproszenia",
              "/signupinvite/:idorganizacji/:idzaproszenia/:host/:redirect",
              "/signupproxy/:product/:host/:redirect",
            ]}
            exact
            component={SingupPage}
          />
          <Route
            path={[
              "/login",
              "/logininvite/:idorganizacji/:idzaproszenia",
              "/logininvite/:idorganizacji/:idzaproszenia/:host/:redirect",
              "/loginproxy/:product/:host/:redirect",
            ]}
            exact
            component={LoginPage}
          />
          <Route path="/resetpassinit" exact component={ResetHaslaInitPage} />
          <Route
            path="/confirmemail/:email/:token"
            exact
            component={ConfirmEmailPage}
          />
          <Route
            path="/resetpass/:email/:token"
            exact
            component={ResetHaslaPage}
          />
          <Route
            path={[
              "/invitation/:idorganizacji/:idzaproszenia",
              "/invitation/:idorganizacji/:idzaproszenia/:host/:redirect",
            ]}
            exact
            component={ZaproszeniePage}
          />
          <Route
            path="/zaproszenieerror"
            exact
            component={ZaproszenieErrorPage}
          />
          <Route path="*" component={LoginPage} />
        </Switch>
      )}
    </AppStyle>
  );
}

function mapStateToProps(store: IDRaksStore) {
  return {
    isLogged: store.auth.isLogged,
    organizacje: store.organizacje.lista,
    zaproszenieError: store.organizacje.zaproszenieError,
    email: store.auth.user,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onGetPersonalData: () => dispatch(authActions.getPersonalData()),
    onDajDostepneProdukty: () =>
      dispatch(settingsActions.dajDostepneProdukty()),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(App) as any
);
